import SubjectSetup from "src/pages/SubjectSetup/SubjectSetup";

export const subjectSetupRoutes = [
  // subject setup
  { path: "/subject/setup", component: SubjectSetup },
];
